import {createAsyncThunk, createReducer} from '@reduxjs/toolkit';

import {ENDPOINTS} from 'constants/endpoints';
import {apiConfig, HTTP_REQUEST_HEADER, HTTP_REQUEST_HEADER_CONTENT_TYPE_VALUE} from 'libs/api/api';

type CouponsStateType = {
    status: string;
    error?: {
        messages: {type: string; message: string}[];
    };
};

/**
 * Add coupon to cart
 * @param {string} name coupon code
 * @returns {ActionType<AxiosPromise>} action
 */
export const addCoupon = createAsyncThunk<
    {data: {messages: []; error: {messages: []}}},
    string,
    {rejectValue: {response: {data: {messages: string[]}}}}
>('COUPON@ADD_COUPON', async (name, {rejectWithValue}) => {
    try {
        return await apiConfig.instanceGusaBackend({
            headers: {
                [HTTP_REQUEST_HEADER.CONTENT_TYPE]:
                    HTTP_REQUEST_HEADER_CONTENT_TYPE_VALUE.APPLICATION_JSON,
            },
            method: 'get',
            url: `${ENDPOINTS.ADD_COUPON}?couponCode=${name}`,
        });
    } catch (e) {
        return rejectWithValue(e);
    }
});

/**
 * Remove coupon from cart
 * @param {string} name coupon code
 * @returns {ActionType<AxiosPromise>} action
 */
export const removeCoupon = createAsyncThunk<
    {data: {messages: []; error: {messages: []}}},
    string,
    {rejectValue: {response: {data: {messages: string[]}}}}
>('COUPON@REMOVE_COUPON', async (name, {rejectWithValue}) => {
    try {
        return await apiConfig.instanceGusaBackend({
            headers: {
                [HTTP_REQUEST_HEADER.CONTENT_TYPE]:
                    HTTP_REQUEST_HEADER_CONTENT_TYPE_VALUE.APPLICATION_JSON,
            },
            method: 'get',
            url: `${ENDPOINTS.REMOVE_COUPON}?couponCode=${name}`,
        });
    } catch (e) {
        return rejectWithValue(e);
    }
});

/**
 * Add and remove coupons data
 *
 * @param {object} state - Current state
 * @param {object} action - Received action
 * @returns {object} coupons data
 */
export const coupons = createReducer<CouponsStateType>(
    {
        status: 'fulfilled',
    },
    builder =>
        builder
            .addCase(addCoupon.fulfilled, (_, action) => ({
                ...action?.payload?.data,
                status: 'fulfilled',
            }))
            .addCase(addCoupon.pending, state => ({...state, status: 'pending'}))
            .addCase(addCoupon.rejected, (state, action) => ({
                ...state,
                error: action?.payload?.response?.data as {messages: []},
                status: 'rejected',
            }))
            .addCase(removeCoupon.fulfilled, (_, action) => ({
                ...action?.payload?.data,
                status: 'fulfilled',
            }))
            .addCase(removeCoupon.pending, state => ({...state, status: 'pending'}))
            .addCase(removeCoupon.rejected, (state, action) => ({
                ...state,
                error: action?.payload?.response?.data as {messages: []},
                status: 'rejected',
            })),
);
